import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleDown,
  faArrowCircleDown,
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';

import { Separator } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
export default function PersistentMenuForm({ localeOptions, integration, persistentMenus }) {
  console.log(localeOptions);
  const RedirectToPersistentMenu = () => {
    window.location.href = '/app/pages/persistentmenu/' + integration.id;
  };
  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center">
          <h6>Persistent Menu</h6>
          <Separator className="mb-3" />
          <div className="mb-1">
            <b>Enable:</b>
            {integration.channelDetails.menuEnabled ? 'Yes' : 'No'}
          </div>
          <div>
            {persistentMenus.length > 0 ? (
              persistentMenus.map((items, index) => {
                return (
                  <Fragment>
                    <h1>
                      {items.locale === 'default'
                        ? 'Default'
                        : localeOptions
                          .filter((i) => i.id.includes(items.locale))
                          .map((item) => item.name) +
                        ' (' +
                        items.locale +
                        ')'}
                    </h1>

                    <div className="row">
                      {items.callToActions.map((menu) => {
                        return (
                          <Fragment>
                            <div className="col-md-4">
                              <p>{menu.title}</p>
                              <div className="mb-2">
                                <span className="text-muted">
                                  ({' '}
                                  {menu.type === 'postback' ? (
                                    <span>
                                      {menu.payLoad}{' '}
                                      <i className="iconsminds-turn-up-2"></i>
                                    </span>
                                  ) : (
                                    <span>
                                      {menu.url}{' '}
                                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                                    </span>
                                  )}{' '}
                                  )
                                </span>
                              </div>
                            </div>
                          </Fragment>
                        );
                      })}
                    </div>
                  </Fragment>
                );
              })
            ) : (
              <Fragment>
                <h4>No persistent menu found</h4>
              </Fragment>
            )}
          </div>
          <NavLink
            to={{ pathname: '/app/pages/persistentmenu/' + integration.id }}
            className={`btn btn-outline-success btn-xs`}
            style={{
              marginTop: '20px',
              display: 'inline-block',
              color: 'white',
            }}
            key={integration.id}
          >
            {' '}
            Edit
          </NavLink>
        </div>
      </CardBody>
    </Card>
  );
}
